module.exports = __webpack_public_path__ + "img/borderRadioWhite.df3502e2.svg";